import Vue from "vue";
import axios from "axios";
import router from "@/router";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import AgentService from "@/common/agent.service";
import { API_URL, API_TEST_URL, API_BLINK_URL } from "@/common/config";

export const Utils = {
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
};

export const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    /*    
    if (JwtService.getToken())
      this.setHeader()*/

    Vue.axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
  },
  setAgent(local = null) {
    if (local === null)
      Vue.axios.defaults.baseURL =
        "http://" + AgentService.getAgent().local + API_URL;
    else Vue.axios.defaults.baseURL = "http://" + local + API_URL;
    console.log(Vue.axios.defaults.baseURL);
  },
  getAgent() {
    Vue.axios.defaults.baseURL =
      "http://" + AgentService.getAgent().local + API_URL;
    console.log(Vue.axios.defaults.baseURL);
  },
  testAgent(host, timeout = 2000) {
    //console.log(Vue.axios.defaults);
    let ret = Vue.axios.get("http://" + host + API_TEST_URL, { timeout: timeout });
    return ret;
  },
  blinkAgent(host) {
    return Vue.axios.get("http://" + host + API_BLINK_URL);
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
  test(timeout) {
    return Vue.axios.get('test', {timeout: timeout});
  },
  get(resource, slug = "") {
    return Vue.axios
      .get(`${resource}/${slug}`, { timeout: 4000 })
      .catch(error => {
        console.log(error);
        if (
          error.response &&
          error.response.status > 400 &&
          error.response.status < 500
        ) {
          router.push({ name: "login" });
        }else {
          router.push({ name: "device-list" });
        }
        throw new Error(`[RWV] ApiService ${error}`);
      });
  },
  findAgents() {
    return new Promise((resolve, reject, onCancel) => {
      //Vue.axios.get('https://api.ipify.org?format=json').then(function({data}) {
      //Vue.axios.get('https://gc0wsv35f2.execute-api.eu-central-1.amazonaws.com/development?public='+data.ip)
      Vue.axios
        .get(
          "https://gc0wsv35f2.execute-api.eu-central-1.amazonaws.com/development"
        )
        .then(result => {
          let gws = result.data;
          //console.log(gws);
          resolve(gws);
        })
        .catch(error => {
          console.log(error);
          reject(error);
          throw new Error(`[RWV] ApiService ${error}`);
        });
    });
    //});
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params, { timeout: 10000 }).catch(error => {
      console.log(error);
      if (
        error.response &&
        error.response.status > 400 &&
        error.response.status < 500
      ) {
        router.push({ name: "login" });
      } else {
        //router.push({ name: "device-list" });
      }
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      console.log(error);

      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;

export const NetworkService = {
  get() {
    return ApiService.get("network");
  },
  save(params) {
    return ApiService.post("network", { request: "save", data: params });
  },
  restart() {
    return ApiService.post("network", {
      request: "start_service",
      service: "networking_restart"
    });
  },
  restart_status() {
    return ApiService.post("network", {
      request: "status_service",
      service: "networking_restart"
    });
  },
  wifi_list() {
    return ApiService.post("network", { request: "wifi-list" });
  },
  wifi_connect(ssid, password) {
    return ApiService.post("network", {
      request: "wifi-connect",
      ssid: ssid,
      password: password
    });
  },
  wifi_wps() {
    return ApiService.post("network", { request: "wifi-wps" });
  },
  wifi_wps_status() {
    return ApiService.post("network", { request: "wifi-wps-status" });
  }
};

export const InfoService = {
  get() {
    return ApiService.get("info");
  }
};

export const DuoService = {
  get(request) {
    let target = "duo";
    if (request) target += "/" + request;

    return ApiService.get(target);
  },
  addUnit(params) {
    return ApiService.post("duo", { request: "add-unit", data: params });
  },
  updateUnit(params) {
    return ApiService.post("duo", { request: "update-unit", data: params });
  },
  removeUnit(params) {
    return ApiService.post("duo", { request: "remove-unit", data: params });
  },
  flatInvite(params) {
    return ApiService.post("duo", { request: "invite", data: params });
  },
  removeInvitation(params) {
    return ApiService.post("duo", {
      request: "remove-invitation",
      data: params
    });
  },
  removeUser(params) {
    return ApiService.post("duo", { request: "remove-user", data: params });
  },
  saveFeatures(params) {
    return ApiService.post("duo", { request: "features", data: params });
  },
  saveSettings(params) {
    return ApiService.post("duo", { request: "settings", data: params });
  }
};

export const UpdateService = {
  startUpdate() {
    return ApiService.post("update", { request: "update" });
  },
  startUpgrade() {
    return ApiService.post("update", { request: "upgrade" });
  },
  getStatusUpdate() {
    return ApiService.get("update/update");
  },
  getStatusUpgrade() {
    return ApiService.get("update/upgrade");
  },
  getListUpgradable() {
    return ApiService.get("update/upgradable-list");
  }
};
export const SystemService = {
  changePassword(params) {
    return ApiService.post("system", {
      request: "change-password",
      data: params
    });
  }
};
